import { DataSource } from '@angular/cdk/table';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MemberResponseInterface } from '@careapp/angular-sdk';
import { BehaviorSubject, Observable } from 'rxjs/Rx';

@Component({
  selector: 'customer-team-table',
  templateUrl: './customer-team-table.component.html'
})
export class CustomerTeamTableComponent implements OnInit {
  @Output() removeMember = new EventEmitter();
  @Input()
  set team(data: MemberResponseInterface[]) {
    this.dataChange.next(data);
  }

  @Input() dataChange: BehaviorSubject<MemberResponseInterface[]> = new BehaviorSubject([]);
  dataSource: CustomerTeamDataSource;
  displayedColumns: string[];

  ngOnInit() {
    this.displayedColumns = ['firstName', 'lastName', 'email', 'role', 'action'];
    this.dataSource = new CustomerTeamDataSource(this.dataChange.asObservable());
  }
}

export class CustomerTeamDataSource extends DataSource<any> {
  constructor(public data: Observable<MemberResponseInterface[]>) {
    super();
  }

  connect(): Observable<MemberResponseInterface[]> {
    return this.data;
  }

  disconnect() {
    // lint
  }
}
